const MediaLibraryEvents = {
    validateCollection: 'validate-collection',
    removeFromCollectionEvent: 'remove-from-collection',
    downloadStartedEvent: 'download-started',
    downloadCompletedEvent: 'download-completed',
    tilesCreatedEvent: 'tiles-created',
    addToCollectionEvent: 'add-to-collection',
    assetSelectedEvent: 'asset-selected',
    noAssetSelectedEvent: 'no-asset-selected'
};

export default MediaLibraryEvents;
